import { DATE_FORMATS } from "@bps/date-time";
import {
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  TooltipHost
} from "@bps/fluent-ui";
import { Selector } from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface SelectorRulesProps {
  selector: Selector;
}

export const SelectorRules = ({ selector }: SelectorRulesProps) => {
  if (selector.rules === null || selector.rules.length === 0) {
    return <Text variant="small">No rules have been configured.</Text>;
  }

  return (
    <Stack
      horizontal
      wrap
      styles={{
        root: {
          width: "100%"
        }
      }}
    >
      {selector.rules.map(rule => (
        <TooltipHost
          content={`First Created: ${rule.changeLog?.createdDate?.toFormat(
            DATE_FORMATS.LONG_DATE_TIME_FORMAT
          ) ?? "No date recorded."}`}
          key={rule.id}
        >
          <TextBadge
            badgeColor={TextBadgeColor.blue}
            badgeSize={TextBadgeSize.medium}
            styles={{
              root: {
                margin: 4,
                padding: "0 8px 1px",
                height: 24,
                lineHeight: "1.385",
                borderRadius: 16,
                display: "inline-flex",
                maxWidth: "100%",
                overflow: "hidden"
              }
            }}
          >
            <Text
              styles={{
                root: {
                  fontSize: 13,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }
              }}
            >
              {rule.attributeType} {rule.comparisonOperator} <b>{rule.value}</b>
            </Text>
          </TextBadge>
        </TooltipHost>
      ))}
    </Stack>
  );
};
